export const oauthErrors = {
  INVALID_TOKEN: {
    words: ["code", "invalid"],
    error: "The code was invalid.",
  },
};
